module.exports = __webpack_public_path__ + "KaTeX_Size4-Regular.74769c90.woff";